/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IDataSelectAccount, IDataTagMount } from '@pacifico/interfaces/components.interface';
import { IDataFirtsStep } from '../../../business/transfers-flow/models/transfers.interface';

@Component({
	selector: 'app-firts-step',
	templateUrl: './firts-step.component.html',
	styleUrls: ['./firts-step.component.scss']
})
export class FirtsStepComponent implements OnChanges {
	@Input() accounts: IDataSelectAccount[] = [];
	@Input() itemSelected: IDataSelectAccount | undefined;
	@Input() itemMount: IDataTagMount = {
		title: '',
		subTitle: '',
		icon: 'icon_saldo_disp'
	};

	@Input() titleInput = 'Ingresa el monto a transferir:';
	@Input() submit = false;

	@Output() firtsData = new EventEmitter<IDataFirtsStep>();

	constructor(private _decimalPipe: DecimalPipe) {}

	mount!: number;
	accountSelected: IDataSelectAccount | undefined;
	availableBalance = '';
	errorMount = '* El monto es obligatorio';
	errorAccount = '* Seleccione una cuenta de origen';

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.itemSelected && changes.itemSelected.currentValue) {
			this.errorAccount = '';
			this.accountSelected = changes.itemSelected.currentValue;
			this._loadMount();
		}
	}

	changeItem(): void {
		this.errorAccount = '';
		this._loadMount();
		this._sendData();
	}

	private _loadMount(): void {
		if (this.accountSelected && this.accountSelected.availableBalance !== undefined) {
			this.itemMount.title = `${this.accountSelected.symbolCoin!} <strong>${this._decimalPipe.transform(
				this.accountSelected.availableBalance,
				'1.2-2'
			)!}</strong>`;
		}

		if (!this.itemMount.subTitle) {
			this.itemMount.subTitle = 'Saldo Disponible';
		}
	}

	changeValue(): void {
		this._sendData();
	}

	private _sendData() {
		this.errorMount = '';
		let isMountValid = true;

		if (isNaN(this.mount)) {
			this.errorMount = '* El monto es obligatorio.';
			isMountValid = false;
		} else if (this.mount == 0) {
			this.errorMount = '* El monto debe ser mayor a cero.';
			isMountValid = false;
		} else if (this.accountSelected && this.mount > this.accountSelected.availableBalance!) {
			this.errorMount = '* El monto es mayor al saldo disponible.';
			isMountValid = false;
		}

		if (!this.accountSelected) {
			this.errorAccount = '* Seleccione una cuenta de origen';
		}

		let isCtsAccount = false;
		if (this.accountSelected && isMountValid) {
			//Esta validación es para poder verificar si es una cuenta CTS
			isCtsAccount =
				(this.accountSelected.serviceArgument === 2 || this.accountSelected.serviceArgument === 1) &&
				this.accountSelected.serviceTable === 103;
			const allowedAmount = this.accountSelected.availableBalance! - this.accountSelected.amountIntangible!;
			if (isCtsAccount && this.mount > allowedAmount) {
				this.errorMount = `* El monto no puede ser mayor al permitido por ley: S/${this._decimalPipe.transform(
					allowedAmount,
					'1.2-2'
				)!}`;
				isMountValid = false;
			}
		}

		if (isMountValid && this.accountSelected) {
			this.errorAccount = '';
			this.firtsData.emit({ mount: this.mount, itemSelected: this.accountSelected, isCtsAccount });
		} else {
			this.firtsData.emit(undefined);
		}
	}
}
